<template>
<div class="papsi-wrapper">
    <div class="papsi-wrapper flex justify-between">
        <div>
            <h1 class="text-2xl font-semibold text-[#24723b]">Training Requisition Requests</h1>
            <p class="text-xs text-[#747474] mt-2">Home / Training Requisition Requests</p>
        </div>
                {{ trainingVerify }}
        <div>
            <button v-if="proBY"  class="py-3 px-5 rounded-md text-sm mr-5 w-[200px] shadow-lg font-semibold border border-[#a8a7a7] hover:bg-[#444]" @click="activeBtn = 'Button1'" v-bind:class="{active: activeBtn === 'Button1',  notactive: activeBtn != 'Button1' }">Indorsement</button>
            <button v-if="recomBY"  class="py-3 px-5 rounded-md text-sm mr-5 w-[200px] shadow-lg font-semibold border border-[#a8a7a7] hover:bg-[#444]" @click="activeBtn = 'Button2'" v-bind:class="{active: activeBtn === 'Button2',  notactive: activeBtn != 'Button2' }">Recommendation</button>
            <button v-if="apvBY"  class="py-3 px-5 rounded-md text-sm mr-5 w-[200px] shadow-lg font-semibold border border-[#a8a7a7] hover:bg-[#444]" @click="activeBtn = 'Button3'" v-bind:class="{active: activeBtn === 'Button3',  notactive: activeBtn != 'Button3' }">Approval</button>
            <button  class="py-3 px-5 rounded-md text-sm  w-[200px] shadow-lg font-semibold border border-[#a8a7a7] hover:bg-[#444]"     @click="activeBtn = 'Button4'" v-bind:class="{active: activeBtn === 'Button4',  notactive: activeBtn != 'Button4' }">History</button>
        </div>
    </div>
</div>
<div class="mt-11 ">
        <div v-if="activeBtn === 'Button4'" class="grid grid-cols-11 w-full gap-3 mb-5 ">
            <input type="text" @input="isTyping = true" placeholder="Search" class="col-span-3 border-[#b7b8b7] border p-2 px-5 rounded-md  outline-none  text-[#535353] text-sm" v-model="search">
            <select @change="trnFilter" class="w-[250px] border-[#b7b8b7] border  rounded-md   outline-none p-2 px-5  text-[#535353]  text-xs font-semibold" v-model="filtered">
                <option value="FR">FOR RECOMMENDATION</option>
                <option value="FA">FOR APPROVAL</option>
                <option value="PB">PROCESS BY (OHR)</option>
                <option value="RB">RECOMMENDED FOR APPROVAL (OHR)  </option>
                <option value="AB">APPROVED BY (OHR)</option>
                <option value="DA">DISAPPROVED</option>
                <option value="AP">APPROVED</option>
                <option value="ALL">ALL</option>
            </select> 
        </div>  
        <div class="mt-8 bg-[#f0f0f0] border-[#ffffff41] border-[3px] p-3 rounded-md shadow">
            <TableControl v-if="activeBtn === 'Button1'" :Action="true" :header="header" :column="column" :info="indorsement" :VButton="true" :EButton="false" :DButton="false" @EditButton="EditButton" @DeleteButton="DeleteButton" @ViewButton="ViewButton" />                
            <TableControl v-if="activeBtn === 'Button2'" :Action="true" :header="header" :column="column" :info="reco"        :VButton="true" :EButton="false"  :DButton="false"  @EditButton="EditButton" @DeleteButton="DeleteButton"   @ViewButton="ViewButton"/>
            <TableControl v-if="activeBtn === 'Button3'" :Action="true" :header="header" :column="column" :info="apv"         :VButton="true" :EButton="false"  :DButton="false"  @EditButton="EditButton" @DeleteButton="DeleteButton"    @ViewButton="ViewButton"/>
            <TableControl v-if="activeBtn === 'Button4'" :Action="true" :header="header" :column="column" :info="history"     :VButton="true" :EButton="false" :DButton="false" @EditButton="EditButton" @DeleteButton="DeleteButton" @ViewButton="ViewButton"/>                                
        </div>

  
  
</div>
<div v-if="trainingModal">
    <TrainingModal @cancel="trainingModal = false" :Data="data" @Process="Processing" @Recommend="Recommend" @Approve="Approve"/>
</div>


<div v-if="success">
    <Prompt type="APPROVE" @close="success = false"/>
</div>

</template>
<script>
import _ from 'lodash';
import { defineComponent } from 'vue';
import TableControl from '.././TableControl/TableControl.vue'
import Services from '../../../services/admin'
import TrainingModal from '../modal/TrainingModal.vue' 
import Prompt from '../Prompt/RequestPromt.vue'

export default defineComponent( {
    components:{
        TableControl,
        TrainingModal,
        Prompt
    },
    data(){
        return{
            filtered:'ALL',
            allTraining:'',
            isTyping:false,
            search:'',
            success: false,
            data:'',
            trainingModal:false,
            activeBtn: 'Button4',
            header:[
                {title:'Reference No.'},
                {title:'Employee Name'},
                {title:'Date Submitted'},
                {title:'Training Category'},
                {title:'Status'},
                {title:'Action'},
            ],
            column:[
                'trainingKey',
                'full_name',
                'dateSubmitted',
                'trainingCategory',
                'training_status'
                ],
                history:'',
                indorsement:'',
                reco:'',
                apv:'',
                trainingVerify:'',
                proBY: false,
                recomBY: false,
                apvBY: false,
            }
        },
        watch: {
                search: _.debounce(function() {
                this.isTyping = false;
                }, 700),
                isTyping: function(value) {
                if (!value) {
                    this.searchTraining()
                }
                }
    },
    mounted(){
        this.verifyTraining()
        this.getTrainingRequest()
    },
        methods:{

            async verifyTraining(){
                let state = this.$store.state

                const success = await Services.verifyTraining(state.employee_key)
                this.proBY      =  success.data.processBy
                this.recomBY    =  success.data.recommendedBy
                this.apvBY      =  success.data.approveBy
            },
           
            async getTrainingRequest(){
                this.$emit("showLoader")
                const success        = await Services.getTrainingRequest(this.search)
                this.allTraining     = success.data
                this.history         = success.data

                const indorsement = await Services.getTrainingIndorsement('PB')
                this.indorsement     = indorsement.data

                const reco = await Services.getTrainingIndorsement('RB')
                this.reco     = reco.data

                const apv = await Services.getTrainingIndorsement('AB')
                this.apv     = apv.data

                this.$emit("hideLoader")
            },
            async searchTraining(){
                const success  = await Services.getTrainingRequest(this.search)
                this.allTraining     = success.data
                this.history         = success.data
            },
            trnFilter(){
            if(this.filtered == 'ALL' ){
                this.history = this.allTraining
                return
            }
                this.history = this.allTraining.filter(status=>status.training_status == this.filtered)
            },
            ViewButton(data){
                this.data           = data
                this.trainingModal  = true
            },
            async Processing(training_key,type){
                this.$emit('showLoader')
                let state = this.$store.state

                const success = await Services.trainingApproval(training_key,state.employee_key,type)
                 
                if(success.success     == true){
                    this.trainingModal  = false
                    this.getTrainingRequest()
                    this.$emit('hideLoader')
                    this.success = true
                }
                this.$emit('hideLoader')
            },
            async Recommend(training_key,type){

                this.$emit('showLoader')
                let state = this.$store.state

                const success = await Services.trainingApproval(training_key,state.employee_key,type)
                 
                if(success.success     == true){
                    this.trainingModal  = false
                    this.getTrainingRequest()
                    this.$emit('hideLoader')
                    this.success = true
                }
                this.$emit('hideLoader')
            },
            async Approve(training_key,type){

                this.$emit('showLoader')
                let state = this.$store.state

                const success = await Services.trainingApproval(training_key,state.employee_key,type)
                 
                if(success.success     == true){
                    this.trainingModal  = false
                    this.getTrainingRequest()
                    this.$emit('hideLoader')
                    this.success = true
                }
                this.$emit('hideLoader')

            }
    }
    })
</script>

<style>
.active {
    color: #ffffff;
    background-color: #24723b;
}
  .notactive {
    background-color: #CCAF12;
    color: #ececec;
}
</style>
